import React from "react";
import { Modal } from "react-bootstrap";

import { CloseButton } from "components";

import AlertIcon from "static/images/alert.png";
import styles from "./noConnection.module.scss";

const NoConnectionModal = ({ show, onHide, dialogAs, backdrop }) => {
	return (
		<Modal
			className={styles.modal}
			show={show}
			animation={false}
			centered
			dialogAs={dialogAs}
			backdrop={backdrop}
		>
			<Modal.Body className={styles.body}>
				<CloseButton onClick={onHide} />
				<img src={AlertIcon} alt="" className={styles.alertIcon} />
				<h1 className={styles.title}>No internet connection</h1>
				<p className={styles.description}>
					Sorry, your internet connection is lost.
					<br />
					Check your network settings and try again.
				</p>
				<a href="#?" className={styles.supportLink}>
					Still have a problem? Contact our support team
				</a>
			</Modal.Body>
		</Modal>
	);
};

export default NoConnectionModal;
